import React, { useContext, useState, useEffect } from 'react';
import Scrollspy from 'react-scrollspy';

import AppContext from '../../../context/AppContext';
import useResponsive from '../../../hooks/useResponsive';
import useScrollDirection from '../../../hooks/useScrollDirection';
import Enquiries from '../../Enquiries/Enquiries';
import Button, { themes, sizes } from '../Button/Button';
import { Dropdown, DropdownButton, DropdownMenu } from '../Dropdown/Dropdown';
import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import NavList from '../NavList/NavList';
import { motion } from '../framer-motion-custom';
import * as styles from './Navbar.module.scss';

const Navbar = ({
  nodes,
  text,
  customButton,
  showBook = false,
  showReferral = false,
  showContact = false,
  showCustom = false,
  pageContext
}) => {
  const { dispatch } = useContext(AppContext);
  const [ isVisible, setVisible ] = useState(false);
  const { isLarge } = useResponsive();
  const ids = nodes.map(({ path }) => path.substr(1));
  const scrollDir = useScrollDirection({ thresholdPixels: 150 });
  const showEnquire = !showContact && !showBook && !showReferral && !showCustom;

  useEffect(() => {
    setVisible(scrollDir === 'down');
  }, [ scrollDir ]);

  function handleEnquiryClick(e) {
    dispatch({
      type: 'MODAL_SHOW',
      modal: {
        children: <Enquiries pageContext={pageContext}/>
      },
    });
  }

  function handleContactClick() {
    dispatch({
      type: 'MODAL_SHOW',
      modal: {
        children: <Enquiries.Contact pageContext={pageContext} />
      },
    });
  }

  function handleBookClick() {
    dispatch({
      type: 'MODAL_SHOW',
      modal: {
        children: <Enquiries.Book pageContext={pageContext} />
      },
    });
  }

  function handleReferralClick() {
    dispatch({
      type: 'MODAL_SHOW',
      modal: {
        children: <Enquiries.RequestScan pageContext={pageContext} />
      },
    });
  }

  return (
    <motion.nav
      className={styles.container}
      initial={{ y: '100%' }}
      animate={{ y: isVisible ? 0 : '100%' }}
    >
      {isLarge ? (
        <Scrollspy
          className={styles.nav}
          items={ids}
          currentClassName={styles.itemIsActive}
        >
          {nodes?.map(({ label, path }) => (
            <li key={path}>
              <Link to={path}>{label}</Link>
            </li>
          ))}
        </Scrollspy>
      ) : (
        <div className={styles.dropdown}>
          <Dropdown>
            <DropdownButton className={styles.toggle}>
              <Icon name="menu" /> On this page
            </DropdownButton>
            <DropdownMenu align="top-left" isFixed>
              <NavList nodes={nodes} isPrimary isReverse />
            </DropdownMenu>
          </Dropdown>
        </div>
      )}

      <div className={styles.text}>{text}</div>

      <div className={styles.controls}>
        {(showEnquire || (!showCustom && !isLarge) ) && (
          <Button
            theme={themes.PRIMARY}
            size={sizes.LARGE}
            isBlock
            hideIcon
            onClick={handleEnquiryClick}
          >
            Book
          </Button>
        )}

        {showContact && isLarge && (
          <Button
            theme={themes.SECONDARY}
            size={sizes.LARGE}
            isBlock
            hideIcon
            onClick={handleContactClick}
          >
            General enquiry
          </Button>
        )}

        {showBook && isLarge && (
          <Button
            theme={themes.PRIMARY}
            size={sizes.LARGE}
            isBlock
            hideIcon
            onClick={handleBookClick}
          >
            Book
          </Button>
        )}

        {showReferral && isLarge && (
          <Button
            theme={themes.PRIMARY}
            size={sizes.LARGE}
            isBlock
            hideIcon
            onClick={handleReferralClick}
          >
            Book a scan
          </Button>
        )}

        {showCustom && (
          <Button
            theme={themes.PRIMARY}
            size={sizes.LARGE}
            isBlock
            hideIcon
            to={customButton.link}
          >
            {customButton.label}
          </Button>
        )}
      </div>
    </motion.nav>
  );
};

export default Navbar;
